import gameNames from 'a/hub/data/GameIds';
import { SCREENS, ACTION_TYPES } from 'a/mindTheGap/data/constants';

const initialState = {
  window: SCREENS.ACTIVITY,
};

const activityReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.MIND_THE_GAP) {
    return state;
  }

  switch (action.type) {
    case ACTION_TYPES.FETCH_CURRICULUM_START:
      return {
        ...state,
        window: SCREENS.LOADING,
      };
    case ACTION_TYPES.FETCH_CURRICULUM_SUCCESS:
    case ACTION_TYPES.FETCH_CURRICULUM_ERROR:
      return {
        ...state,
        window: SCREENS.ACTIVITY,
      };
    default:
      return state;
  }
};

export default activityReducer;
